// The only country that should see PHP is the Philippines
const phpCountry = 'PH';

// Function to update prices on the page
function updateCollectionPrices(detectedCountry) {
  const priceElements = document.querySelectorAll('[data-usd-price]');

  if (priceElements.length === 0) {
    console.log('No product price elements with data-usd-price found on this collection page.');
    return;
  }

  // Display USD if the detected country is NOT the Philippines
  const shouldDisplayUsd = (detectedCountry !== phpCountry);

  priceElements.forEach(priceElement => {
    const productUsdPrice = parseFloat(priceElement.dataset.usdPrice);

    if (shouldDisplayUsd && typeof productUsdPrice === 'number' && productUsdPrice > 0) {
      const formattedUsdPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(productUsdPrice);

      priceElement.innerHTML = formattedUsdPrice;
      // IF you added data-usd-compare-at-price AND want to convert it:
      const compareAtPriceElement = priceElement.closest('.product-item__price-wrapper').querySelector('[data-usd-compare-at-price]');
      if (compareAtPriceElement) {
        const productUsdCompareAtPrice = parseFloat(compareAtPriceElement.dataset.usdCompareAtPrice);
        if (typeof productUsdCompareAtPrice === 'number' && productUsdCompareAtPrice > 0) {
          compareAtPriceElement.innerHTML = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(productUsdCompareAtPrice);
        }
      }

    } else {
      // If in the Philippines or USD price not found, price remains in PHP.
    }
  });

  if (shouldDisplayUsd) {
    console.log('Collection prices updated to USD.');
  } else {
    console.log('Detected country is Philippines. Collection prices remain in PHP.');
  }
}

// --- Client-side Geo-location API Call ---
fetch('https://ipapi.co/json/')
  .then(response => response.json())
  .then(data => {
    const detectedCountry = data.country_code;
    console.log('Detected Country (Client-side, Collection):', detectedCountry);
    updateCollectionPrices(detectedCountry);
  })
  .catch(error => {
    console.error('Error fetching geo-location for collection:', error);
    console.log('Geo-location failed for collection, displaying default (PHP).');
  });